import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const BlogDtl = () => {
 

  return (
    <>
      <Header />
      
      <main className="min-h-screen bg-[#0F172A]">
      {/* Top Section */}
      <div className="relative w-full bg-slate-50 py-12 md:py-24">
        <div className="container mx-auto">
          <div className="grid">
            <div className="snap-start mb-8 blog-dtl-sec">
              <div className="group relative overflow-hidden rounded-2xl transition-all duration-500 border border-slate-100 cursor-pointer h-full">
                <div className="relative h-150 md:h-150 w-full overflow-hidden">
                  <img
                    alt="Rahul Sharma"
                    loading="lazy"
                    decoding="async"
                    className="object-cover transition-transform duration-700 group-hover:scale-110 h-full w-full"
                    src="/assets/images/blog1.jpg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent transition-opacity duration-300 group-hover:opacity-70"></div>
                </div>
                <div className="p-2 md:p-5 bg-white rounded-lg border shadow-xl blog-dtl-body">
                  <h3 className="text-base md:text-2xl font-bold mb-2 md:mb-3 group-hover:text-primary/90 transition-colors duration-300">
                    Five-star Golden Tour Review!
                  </h3>
                  <div className="flex items-center justify-between mb-2 md:mb-3">
                    <div className="flex items-center">
                      <p className="text-sm text-slate-500">By Admin</p>
                    </div>
                    <p className="text-sm text-slate-500">March 23, 2025</p>
                  </div>
                  <div className="text-xs md:text-sm text-slate-600">
                    <p className="mb-4 md:mb-2">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam
                      eveniet inventore rerum pariatur ad dolore sapiente repudiandae
                      voluptatum? Quasi sunt pariatur quas doloremque itaque ut
                      eveniet dolorum nisi vero totam.
                    </p>
                    <p className="mb-4 md:mb-2">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet
                      delectus quibusdam magnam nam deserunt enim, facilis quos natus
                      sunt magni!
                    </p>
                    <p className="mb-4 md:mb-2">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Et,
                      quo!
                    </p>
                    {/* Image Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-4 pb-5 reveal-on-scroll">
                      <div className="relative h-90 md:h-90 w-full overflow-hidden mb-3">
                        <img
                          alt="Rahul Sharma"
                          loading="lazy"
                          decoding="async"
                          className="object-cover transition-transform duration-700 group-hover:scale-110 h-full w-full"
                          src="/assets/images/blog1.jpg"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent transition-opacity duration-300 group-hover:opacity-70"></div>
                      </div>
                      <div className="relative h-90 md:h-90 w-full overflow-hidden mb-3">
                        <img
                          alt="Rahul Sharma"
                          loading="lazy"
                          decoding="async"
                          className="object-cover transition-transform duration-700 group-hover:scale-110 h-full w-full"
                          src="/assets/images/blog1.jpg"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent transition-opacity duration-300 group-hover:opacity-70"></div>
                      </div>
                    </div>
                    <p>
                      Contact us to plan your dream trip to India <a className="text-primary" href="/contact">here.</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Experts Section */}
      <section className="relative w-full bg-slate-100 py-10 md:py-14 text-slate-800 featured-experts-section">
        {/* Decorative Blurs */}
        <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
        <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
        <div className="container mx-auto px-4 md:px-6">
          {/* Header */}
          <div className="mb-10 md:mb-12 reveal-on-scroll revealed">
            <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
              <div>
                <div className="mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary hover-lift">
                  <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>
                  Featured Experts
                </div>
                <h2 className="mb-2 text-xl font-bold tracking-tight text-slate-800 sm:text-2xl md:text-4xl">
                  Similar <span className="text-gradient">Post</span>
                </h2>
              </div>
              {/* View All Button */}
              <div className="flex items-center gap-2 text-sm font-medium">
                <span className="hidden text-primary md:inline">View all Post</span>
                <button
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border hover:text-accent-foreground h-9 rounded-md px-3 border-primary/30 bg-transparent hover:bg-primary/10 btn-pulse"
                >
                  <span className="md:hidden">View all Post</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right h-4 w-4"
                  >
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Carousel */}
          <div className="relative -mx-4 px-4 reveal-on-scroll revealed">
            {/* Previous Button */}
            <button
              className="customPrevBtn absolute -left-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-2"
              aria-label="Previous expert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left h-5 w-5"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
            {/* Carousel Items */}
            <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-6 scrollbar-hide owl-carousel featured-experts-owl">
              {/* Sample Item */}
              {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="snap-start mb-8">
                  <div className="group relative overflow-hidden rounded-2xl bg-white shadow-xl transition-all duration-500 hover-lift h-full border border-slate-100 cursor-pointer">
                    <div className="relative h-40 md:h-64 w-full overflow-hidden">
                      <img
                        alt="Rahul Sharma"
                        loading="lazy"
                        decoding="async"
                        className="object-cover transition-transform duration-700 group-hover:scale-110 h-full w-full"
                        src="/assets/images/blog1.jpg"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent transition-opacity duration-300 group-hover:opacity-70"></div>
                    </div>
                    <div className="p-2 md:p-5">
                      <h3 className="text-base md:text-2xl font-bold mb-2 md:mb-3 group-hover:text-primary/90 transition-colors duration-300">
                        Five-star Golden Tour Review!
                      </h3>
                      <div className="flex items-center justify-between mb-2 md:mb-3">
                        <div className="flex items-center">
                          <p className="text-xs text-slate-500">By Admin</p>
                        </div>
                        <p className="text-xs text-slate-500">March 23, 2025</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Next Button */}
            <button
              className="customNextBtn absolute -right-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-2"
              aria-label="Next expert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right h-5 w-5"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </main>

      <Footer />
    </>
  );
};

export default BlogDtl;
